import { Icon } from './Icon';

interface PointsPillProps {
  points: number;
  prefix?: string;
  tone?: 'tint' | 'solid';
}

/** "+15 pts" / "até 15 pts" label. */
export function PointsPill({
  points,
  prefix = '+',
  tone = 'tint',
}: PointsPillProps) {
  return (
    <span className={`pv-pill pv-pill--points pv-pill--${tone}`}>
      <Icon name="bolt" size={13} />
      {prefix}
      {prefix === '+' ? '' : ' '}
      {points} pts
    </span>
  );
}
